// import { CompanyRecord as CompanyRecordOld } from 'packages/core/records-old'
import { Company } from 'packages/core/records'

// export const ReducerRecord = CompanyRecordOld
export const ReducerRecord = Company
